// extracted by mini-css-extract-plugin
export default {"subTableHeader":"TableHeader_subTableHeader__K0A1Q"};